module.exports = __webpack_public_path__ + "img/supreme.ee72e8f4.png";